package com.dignicate.web.domain

import com.dignicate.web.domain.mapToResource
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.StateFlow

/**
 * メイン画面のコンテンツを取得する UseCase
 * CMS から画面構成情報を取得する汎用的な仕組み
 */
class GetMainPageContentUseCase(
    private val repository: com.dignicate.web.domain.ContentRepository,
    private val lang: com.dignicate.web.domain.Language,
    scope: CoroutineScope = CoroutineScope(Dispatchers.Default),
) {

    private val fetchTrigger = MutableSharedFlow<Unit>(
        replay = 1,
        extraBufferCapacity = 0
    ).also {
        console.log("[GetMainPageContentUseCase] fetchTrigger created")
    }

    init {
        console.log("[GetMainPageContentUseCase] init START with lang: $lang")
        console.log("[GetMainPageContentUseCase] scope:", scope)
    }

    val data: StateFlow<com.dignicate.web.domain.Resource<com.dignicate.web.domain.MainPageContent>> =
        fetchTrigger
            .also { console.log("[GetMainPageContentUseCase] About to call mapToResource on fetchTrigger") }
            .mapToResource(
                scope = scope,
                then = { unit ->
                    console.log("[GetMainPageContentUseCase] then() called with param:", unit)
                    repository.getMainPageContent(lang)
                },
            ).also {
                console.log("[GetMainPageContentUseCase] data StateFlow created, initial value:", it.value)
            }

    suspend fun fetch() {
        console.log("[GetMainPageContentUseCase] fetch() START for lang: $lang")
        console.log("[GetMainPageContentUseCase] fetchTrigger subscriptionCount:", fetchTrigger.subscriptionCount.value)
        fetchTrigger.emit(Unit)
        console.log("[GetMainPageContentUseCase] fetch() END - Unit emitted to fetchTrigger")
    }
}
